import { Serializable } from '../../../core/models/serializable';
import { ProductModel } from '@admin/product-purchases/shared/models/product-model';

export class StoreItemModel implements Serializable<StoreItemModel> {
  fromObject(obj: any): StoreItemModel {
    Object.assign(this, obj);
    if (obj.product != null) {
      let p = new ProductModel();
      this.product = p.fromObject(obj.product);
    }

    return this;
  }
  toObject() {
    return {
      ItemId: this.itemId,
    };
  }

  public itemId: number;

  //public Seller Seller

  public product: ProductModel;
  public price: number;
  public isAvailable: boolean;
  public providerWebsite: any;
}
